import {action, Action} from 'easy-peasy';

interface UserActivityState {
    activeUser: number;
    items: any[];
    searchPagesList: any[];
    searchCurrentPage: number;
    loading: boolean;
}

interface UserActivityActions {
    setActiveUser: Action<UserActivityState, number>;
    loadUserActivity: Action<UserActivityState, any[]>;
    setSearchPagesList: Action<UserActivityState, any[]>;
    setSearchCurrentPage: Action<UserActivityState, number>;
    setLoading: Action<UserActivityState, boolean>;
}

type UserActivityStore = UserActivityState & UserActivityActions;

const userActivityStore: UserActivityStore = {
    activeUser: 0,
    setActiveUser: action((state, activeUser) => {
        state.activeUser = activeUser;
    }),
    items: [],
    loadUserActivity: action((state, userActivityList) => {
        state.items = userActivityList;
    }),
    searchPagesList: [],
    setSearchPagesList: action((state, searchPagesList) => {
        state.searchPagesList = searchPagesList;
    }),
    searchCurrentPage: 1,
    setSearchCurrentPage: action((state, searchCurrentPage) => {
        state.searchCurrentPage = searchCurrentPage;
    }),
    loading: false,
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),
};

export default userActivityStore;
